import { Factory, trait } from 'miragejs';

const PLANS = [
  {
    app: 'visitors',
    id: 'basic',
    name: 'Basic',
    monthlyPrice: 0,
    yearlyPrice: 0,
  },
  {
    app: 'visitors',
    id: 'standard',
    name: 'Premium',
    monthlyPrice: 119,
    yearlyPrice: 99,
  },
  {
    app: 'visitors',
    id: 'standard-1',
    name: 'Standard',
    monthlyPrice: 119,
    yearlyPrice: 99,
  },
  {
    app: 'visitors',
    id: 'premium',
    name: 'Premium',
    monthlyPrice: 359,
    yearlyPrice: 299,
  },
  {
    app: 'visitors',
    id: 'enterprise',
    name: 'Enterprise',
    yearlyPrice: 999,
  },
  {
    app: 'deliveries',
    id: 'deliveries-standard',
    name: 'Deliveries Standard',
    monthlyPrice: 199,
    yearlyPrice: 159,
  },
  {
    app: 'rooms',
    id: 'rooms-standard',
    name: 'Rooms Standard',
    monthlyPrice: 21,
    yearlyPrice: 18,
  },
  {
    app: 'desks',
    id: 'desks-standard',
    name: 'Standard Desks',
    monthlyPrice: 119,
    yearlyPrice: 99,
  },
  {
    app: 'empxp',
    id: 'empxp-standard',
    name: 'Workplace Standard',
    monthlyPrice: 3,
    yearlyPrice: 3,
  },
  {
    app: 'empxp',
    id: 'empxp-premium',
    name: 'Workplace Premium',
    monthlyPrice: 5,
    yearlyPrice: 5,
  },
  {
    app: 'empxp',
    id: 'empxp-premium-plus',
    name: 'Workplace Premium Plus',
    monthlyPrice: 7,
    yearlyPrice: 7,
    period: 'yearly',
  },
  {
    app: 'vfd',
    id: 'vfd-standard',
    name: 'Virtual Front Desk Standard',
    monthlyPrice: 199,
    yearlyPrince: 199,
    period: 'yearly',
  },
];

export default Factory.extend({
  id(i) {
    return PLANS[i % PLANS.length].id;
  },

  name(i) {
    return PLANS[i % PLANS.length].name;
  },

  monthlyPrice(i) {
    return PLANS[i % PLANS.length].monthlyPrice;
  },

  yearlyPrice(i) {
    return PLANS[i % PLANS.length].yearlyPrice;
  },

  visitorsBasic: trait(PLANS[0]),
  visitorsStandardLegacy: trait(PLANS[1]),
  visitorsStandard: trait(PLANS[2]),
  visitorsPremium: trait(PLANS[3]),
  visitorsEnterprise: trait(PLANS[4]),
  deliveriesStandard: trait(PLANS[5]),
  roomsStandard: trait(PLANS[6]),
  desksStandard: trait(PLANS[7]),
  workplaceStandard: trait(PLANS[8]),
  workplacePremium: trait(PLANS[9]),
  workplacePremiumPlus: trait(PLANS[10]),
  virtualFrontDeskStandard: trait(PLANS[11]),
});
